if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    const heroSliders = document.querySelectorAll('.ct_heroslider:not(.admin_preview)');

    if (heroSliders) {
        heroSliders.forEach((sliderContainer) => {
            const slider = sliderContainer.querySelector('.slider');

            if (!slider) {
                return;
            }

            const navContainer = sliderContainer.querySelector('.slickNav');
            const pagination = sliderContainer.querySelector('.slickPagination');
            const sliderOptions = {
                arrows: true,
                infinite: true,
                appendArrows: navContainer ?? slider,
                prevArrow: '<button class="btn slick-prev"><i class="fal fa-long-arrow-left"></i></button>',
                nextArrow: '<button class="btn slick-next"><i class="fal fa-long-arrow-right"></i></button>',
                autoplay: true,
                autoplaySpeed: 15000,
            };

            jQuery(slider).slick(sliderOptions);

            if (pagination) {
                const slickObject = jQuery(slider).slick('getSlick');
                const { currentSlide, slideCount } = slickObject;
                const current = pagination.querySelector('.current-slide');
                const total = pagination.querySelector('.total-slides');

                if (current) {
                    current.textContent = currentSlide + 1;
                }

                if (total) {
                    total.textContent = slideCount;
                }

                jQuery(slider).on('afterChange', (e, slick, currentSlide) => {
                    current.textContent = currentSlide + 1;
                });
            }
        });
    }
}
